import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";
import InputContainer, {
  InputContainerProps
} from "../../elements/InputContainer";
import { inputResetStyle } from "../../elements/TextInput";
import mergeHandlers from "../../util/mergeHandlers";
import mergeStyles from "../../util/mergeStyles";

const Input = styled.input`
  ${inputResetStyle}
  flex: 1;
`;

const ColorBox = styled.div<{ value?: string }>`
  transition: filter 0.2s;
  width: 50px;
  height: 100%;
  background-color: ${p => p.value || select.color(["grey", 2], p)};
  margin-left: ${select.space(2)};
  border-top-right-radius: calc(${select.radius("light")} - 1px);
  border-bottom-right-radius: calc(${select.radius("light")} - 1px);
  cursor: pointer;

  &:hover {
    filter: brightness(1.1);
  }
`;

type ColorInputProps = {
  style?: React.CSSProperties;
  className?: string;
  label?: string;
  containerRef?: any;
  value?: string | null;
  onColorClick?: () => void;
} & InputContainerProps &
  React.HTMLAttributes<HTMLInputElement>;

const ColorInput = React.forwardRef(function ColorInput(
  {
    containerRef,
    style,
    className,
    disabled,
    error,
    label,
    focus,
    stretch,
    onClick,
    value,
    onColorClick,
    ...rest
  }: ColorInputProps,
  ref: any
) {
  const [hasFocus, setFocus] = React.useState(false);
  const inputRef = React.useRef<HTMLInputElement>(null);
  const colorBoxRef = React.useRef<HTMLInputElement>(null);

  return (
    <InputContainer
      ref={ref}
      className={className}
      style={mergeStyles(style, { paddingRight: 0 })}
      focus={hasFocus}
      disabled={disabled}
      error={error}
      stretch={stretch}
      label={label}
      onClick={(evt: any) => {
        if (
          evt.target !== inputRef.current &&
          evt.target !== colorBoxRef.current
        ) {
          inputRef.current!.focus();
        }
      }}
    >
      <Input
        {...rest}
        value={value!}
        disabled={disabled}
        onFocus={mergeHandlers(rest.onFocus, () => {
          setFocus(true);
        })}
        onBlur={mergeHandlers(rest.onBlur, () => {
          setFocus(false);
        })}
      />
      <ColorBox onClick={onColorClick} ref={colorBoxRef} value={value!} />
    </InputContainer>
  );
});

export default ColorInput;
